import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import {
  PublicGuideDetail,
  PublicGuideListItem,
  mapPublicGuideDetail,
  mapPublicGuideListItem,
} from '../../../models/public-guide.model';
import { ManualContact, mapManualContact } from '../../../models/manual-contact.model';

@Injectable({
  providedIn: 'root',
})
export class ApiPublicGuideService {
  private readonly apiUrl = `${environment.apiPrivateUrl}`;

  constructor(private http: HttpClient) {}

  getPublicGuides(guideKind?: 'parking' | 'ev' | null): Observable<PublicGuideListItem[]> {
    let params = new HttpParams();
    if (guideKind === 'parking' || guideKind === 'ev') {
      params = params.set('guideKind', guideKind);
    }
    return this.http
      .get<any[]>(`${this.apiUrl}/CityParking/getPublicGuides`, { params })
      .pipe(map((rows) => (Array.isArray(rows) ? rows.map(mapPublicGuideListItem) : [])));
  }

  getPublicGuideBySlug(slug: string): Observable<PublicGuideDetail> {
    const params = new HttpParams().set('slug', slug);
    return this.http
      .get<any>(`${this.apiUrl}/CityParking/getPublicGuideBySlug`, { params })
      .pipe(map(mapPublicGuideDetail));
  }

  getPublicManualContact(): Observable<ManualContact> {
    return this.http
      .get<any>(`${this.apiUrl}/CityParking/getPublicManualContact`)
      .pipe(map(mapManualContact));
  }
}
